import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { SubscriptionState } from "models/subscription";

const initialState: SubscriptionState = {
  loading: false,
  data: {},
  allData: {},
  message: "",
  success: false,
  subscriptionByIdLoading: false,
  subscriptionByIdSuccess: false,
  subscriptionByIdData: {},
  updateMessage: "",
  updateLoading: false,
  deleteMessage: "",
  deleteLoading: false,
  deleteSuccess: false,
  storeListDataLoading: false,
  storeListDataMessage: "",
  storeListDataSuccess: false,
  storeListData: [],
};

const subscriptionSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    getSubscription(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getSubscriptionSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action?.payload;
      state.success = action.payload?.success;
    },
    getSubscriptionFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getSubscriptionById(state, action: PayloadAction<ApiResponse>) {
      state.subscriptionByIdLoading = true;
      state.subscriptionByIdData = {};
      state.subscriptionByIdSuccess = false;
    },
    getSubscriptionByIdSuccess(state, action: PayloadAction<ApiResponse>) {
      state.subscriptionByIdLoading = false;
      state.subscriptionByIdData = action?.payload.data;
      state.subscriptionByIdSuccess = action.payload?.success;
    },
    clearSubscriptionByIdSuccess(state) {
      state.subscriptionByIdLoading = false;
      state.subscriptionByIdSuccess = false;
    },
    getSubscriptionByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.subscriptionByIdLoading = false;
      state.subscriptionByIdData = {};
      state.subscriptionByIdSuccess = action.payload?.success;
    },
    getAllSubscription(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.allData = {};
      state.message = "";
    },
    getAllSubscriptionSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.allData = action.payload?.data;
      state.success = action.payload?.success;
    },
    getAllSubscriptionFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.allData = {};
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    updateSubscription(state, action: PayloadAction<ApiResponse>) {
      state.updateLoading = true;
      state.message = "";
    },
    updateSubscriptionSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateLoading = false;
      state.updateMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateSubscriptionFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateLoading = false;
      state.updateMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteSubscription(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteSubscriptionSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload?.message;
      state.deleteSuccess = action.payload?.success;
    },
    deleteSubscriptionFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.deleteSuccess = action.payload.success;
    },
    getStoreList(state, action: PayloadAction<ApiResponse>) {
      state.storeListDataLoading = true;
      state.storeListDataMessage = "";
    },
    getStoreListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.storeListDataLoading = false;
      state.storeListData = action.payload.storeName;
      state.storeListDataSuccess = action.payload.success;
    },
    getStoreListFailed(state, action: PayloadAction<ApiResponse>) {
      state.storeListDataLoading = false;
      state.storeListDataMessage = action.payload.message;
      state.storeListDataSuccess = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.updateMessage = "";
      state.deleteMessage = "";
      state.imageUrl = "";
    },
  },
});

//Actions
export const subscriptionAction = subscriptionSlice.actions;

//Selectors
export const getSubscriptionData = (state: RootState) =>
  state.subscription.data;
export const getSubscriptionById = (state: RootState) =>
  state.subscription.subscriptionByIdData;
export const getSubscriptionByIdSuccess = (state: RootState) =>
  state.subscription.subscriptionByIdSuccess;
export const getAllSubscription = (state: RootState) =>
  state.subscription.allData;
export const selectIsLoading = (state: RootState) => state.subscription.loading;
export const updateLoading = (state: RootState) =>
  state.subscription.updateLoading;
export const updateMessage = (state: RootState) =>
  state.subscription.updateMessage;
export const deleteSubscriptionLoading = (state: RootState) =>
  state.subscription.deleteLoading;
export const deleteSubscriptionMsg = (state: RootState) =>
  state.subscription.deleteMessage;
export const storeListData = (state: RootState) =>
  state.subscription.storeListData;

//Reducers
const subscriptionReducer = subscriptionSlice.reducer;
export default subscriptionReducer;
